module.exports = __webpack_public_path__ + "static/img/lg-archive-img-02-01@t.f383c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/lg-archive-img-02-01@t.jpg
// module id = oxk9
// module chunks = 0